import { getIndicadorByField } from "entity/Indicador/all";
import { getTiposIndicadorByField } from "entity/TipoIndicador/all";
import _ from "lodash";
import Operador from "entity/Operador";
import { getTalhaoNomeDisplay, getTalhaoAreaDisplay } from "entity/Indicador/reports/talhaoDisplay";

const getOperadoresByUid = async () => {
    const map = {};

    try {
        const operadores = await Operador.getAllQuery();
        operadores.forEach((op) => {
            if (op?.uid) {
                map[op.uid] = op.operador || op.nome || "";
            }
        });
    } catch (err) {
        console.error("Falha ao carregar operadores para exportacao CSV", err);
    }

    return map;
};

const getOperadorFiel = (apontamento, operadoresByUid = {}) => {
    if (apontamento?.operador && typeof apontamento.operador === "object") {
        const nomeOperador =
            apontamento.operador.operador ||
            apontamento.operador.nome ||
            apontamento.operador.nomeOperador ||
            apontamento.operador.label ||
            apontamento.operador?.data?.operador ||
            apontamento.operador?.data?.nome ||
            "";

        if (nomeOperador) {
            return nomeOperador;
        }

        const uidOperador = apontamento.operador.uid || apontamento.operador?.data?.uid || "";
        if (uidOperador && operadoresByUid[uidOperador]) {
            return operadoresByUid[uidOperador];
        }
    }

    if (typeof apontamento?.operador === "string" && apontamento.operador) {
        return apontamento.operador;
    }

    const uidOperadorFallback = apontamento?.operadorUid || apontamento?.operadorRef?.uid || "";
    if (uidOperadorFallback && operadoresByUid[uidOperadorFallback]) {
        return operadoresByUid[uidOperadorFallback];
    }

    return "";
};

const gerarArquivo = (texto, nome) => {
    let fileBlob = new Blob(["\ufeff", texto]);
    if (window.cordova) {
        document.addEventListener("deviceready", function () {
            var storageLocation = "";
            storageLocation = window.cordova.file.dataDirectory;

            var folderPath = storageLocation;
            window.resolveLocalFileSystemURL(
                folderPath,
                function (dir) {
                    console.log("Access to the directory granted succesfully", dir);
                    dir.getFile(
                        nome,
                        {
                            create: true,
                        },
                        function (file) {
                            console.log("file", file);
                            file.createWriter(
                                function (fileWriter) {
                                    fileWriter.write(fileBlob);

                                    fileWriter.onwriteend = function () {
                                        var url = file.toURL();
                                        console.log("url", url);
                                        window.cordova.plugins.fileOpener2.open(folderPath + nome, "text/plain", {
                                            error: function error(err) {
                                                console.error(err);
                                                alert("Unable to download3");
                                            },
                                            success: function success() {
                                                console.log("success with opening the file");
                                            },
                                        });
                                    };

                                    fileWriter.onerror = function (err) {
                                        alert("Unable to download2");
                                        console.error(err);
                                    };
                                },
                                function (err) {
                                    // failed
                                    alert("Unable to download");
                                    console.error("err", err);
                                },
                            );
                        },
                        function (err) {
                            alert("Unable to download");
                            console.error(err);
                        },
                    );
                },
                function (err) {
                    alert("Unable to download");
                    console.error(err);
                },
            );
        });
    } else {
        var element = document.createElement("a");

        element.href = URL.createObjectURL(fileBlob);
        element.download = nome;
        element.click();
    }
};

const createCSVContent = (list, conf) => {
    let strCsv = "";
    let separator = ";";
    conf.forEach((c) => {
        strCsv += c.labelCol + separator;
    });
    strCsv += "\n";

    list.forEach((l) => {
        conf.forEach((c) => {
            let v = "";
            if (_.isString(c.getValue)) {
                v = _.get(l, c.getValue);
                if (v) {
                    v = '"' + v + '"';
                }
            } else {
                v = c.getValue(l);
            }
            if (!v) {
                v = "";
            }
            strCsv += v + separator;
        });
        strCsv += "\n";
    });

    gerarArquivo(strCsv, `ExportarCSVTCH.csv`);
};

const exportarCSV = (list, columns) => {
    let conf = columns;

    if (list.length) {
        createCSVContent(list, conf);
    } else {
        console.log("Lista vazia p/ criação de CSV");
    }
};

const exportFile = async (laudos) => {
    let list = [];
    const operadoresByUid = await getOperadoresByUid();

    for (let i = 0; i < laudos.length; i++) {
        if (laudos[i].apontamentos) {
            for (const fTipoClass of Object.keys(laudos[i].apontamentos)) {
                const TipoClass = getTiposIndicadorByField(fTipoClass);
                if (!TipoClass) {
                    continue;
                }

                for (const fIndicadorClass of Object.keys(laudos[i].apontamentos[fTipoClass])) {
                    const IndicadorClass = getIndicadorByField(fIndicadorClass);
                    if (!IndicadorClass) {
                        continue;
                    }

                    let apontamentosProps = _.get(laudos[i].apontamentos, `${TipoClass.field}.${IndicadorClass.field}`);

                    if (Array.isArray(apontamentosProps) && apontamentosProps.length) {
                        for (const apontamento of apontamentosProps) {
                            const operadorCsv = getOperadorFiel(apontamento, operadoresByUid);

                            let auxApontamento = {
                                ...apontamento,
                                resultStr: IndicadorClass.getResultStr(apontamento),
                                operadorCsv,
                                indicadorName: IndicadorClass.fullName,
                            };
                            list.push(auxApontamento);
                        }
                    }
                }
            }
        }
    }
    console.log("list ", list);


    const columns = [
        { labelCol: "Data", width: "auto", getValue: (a) => a.dataRef?.split("-").reverse().join("/") },
        {
            labelCol: "Código do Cliente",
            getValue: (a) => {
                let cli =
                    a.laudoRef?.cliente?.sequencialIndex ||
                    a.trator?.cliente?.sequencialIndex ||
                    a.implemento?.cliente?.sequencialIndex;
                return cli;
            },
            width: 28,
        },
        {
            labelCol: "Cliente",
            getValue: (a) => {
                let cli = a.laudoRef?.cliente?.nome || a.trator?.cliente?.nome;
                return cli;
            },
            width: 28,
        },
        {
            labelCol: "Data",
            width: "auto",
            getValue: (a) => {
                return a.dataRef?.split("-").reverse().join("/");
            },
        },
        { labelCol: "Laudo", getValue: "laudoRef.sequencialIndex", width: 28 },
        { labelCol: "Código", getValue: "laudoRef.fazenda.codFazenda", width: "auto" },
        { labelCol: "Fazenda", getValue: "laudoRef.fazenda.nomeFazenda" },

        {
            labelCol: "Talhão",
            getValue: (v) => getTalhaoNomeDisplay(v),
        },

        {
            labelCol: "Área do Talhão (ha)",
            getValue: (v) => getTalhaoAreaDisplay(v),
        },

        // { labelCol: "Variedade", getValue: "variedade.variedade", width: "auto" },
        // { labelCol: "Corte", getValue: "corte", width: "auto" },

        { labelCol: "Frota", getValue: "trator.numeroFrotaTrator", width: "auto" },
        {
            labelCol: "Frente",
            getValue: (v) => {
                if (v.frente && typeof v.frente === "object") {
                    return v.frente.frente;
                } else {
                    return v.frente;
                }
            },
            width: "auto",
        },
        { labelCol: "Operador", getValue: "operadorCsv", width: "auto" },
        {
            labelCol: "Equipamento",
            getValue: (v) => {
                if (v.equipamento && typeof v.equipamento === "object") {
                    return v.equipamento.equipamento;
                } else {
                    return v.equipamento;
                }
            },
            width: "auto",
        },
        { labelCol: "Turno", getValue: "turno", width: "auto" },
        {
            labelCol: "Variedade",
            getValue: (v) => {
                if (v.insumo && v.insumo.nomeInsumo) {
                    return v.insumo.nomeInsumo;
                } else if (typeof v.insumo === "string") {
                    return v.insumo;
                } else {
                    return "";
                }
            },
            width: "auto",
        },
        { labelCol: "Implemento", getValue: "implemento.nomeImplemento", width: "auto" },

        { labelCol: "Tipo", getValue: "tipo" },
        { labelCol: "Indicador", getValue: "indicadorName", width: "auto" },
        { labelCol: "Dados Epecíficos do Indicador", getValue: "resultStr", width: "auto" },

        { labelCol: "Conf.(%)", getValue: "conformidade", width: "auto" },
    ];

    exportarCSV(list, columns);
};

const configExport = { nome: "Exportar CSV", exportFile: exportFile };
export default configExport;
